import { useIntl, type PrimitiveType } from 'react-intl';
import type { FormatXMLElementFn } from 'intl-messageformat';

type FormatValues = Record<string, PrimitiveType | FormatXMLElementFn<string, string>>;

export const useIntlTranslations = (
  prefix?: string,
): { t: (key: string, values?: FormatValues) => string } => {
  const { formatMessage } = useIntl();

  return {
    t: (key: string, values?: FormatValues) =>
      formatMessage({ id: prefix ? `${prefix}.${key}` : key }, values),
  };
};
